import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../layout/Navbar";
import job_application from "../assests/Images/job_application.jpg";
import basic_info from "../assests/Images/information_icon.png";
import qualification from "../assests/Images/qualification_icon.png";
import Footer from "../layout/Footer";
import Toast from "../Components/Toast";

const JobApplication = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    experience: "",
    resumeFile: null,
  });

  const [errors, setErrors] = useState({});
  const [industryData, setIndustryData] = useState([]);
  const [industryDomain, setIndustryDomain] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState("Select Industry");
  const [selectedIndustryDomain, setSelectedIndustryDomain] =
    useState("Select Domain");
  const [showToast, setShowToast] = useState("");

  const BASE_URL = "https://app.gigleji.com";

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/industry/`)
      .then((response) => {
        const data = response?.data?.result?.data;
        setIndustryData(data || []);
      })
      .catch((error) => console.error("Industry error:", error));
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/domain`)
      .then((response) => {
        const allDomains = response?.data?.result?.data || [];
        const filtered = allDomains.filter(
          (d) => d.Industry === selectedIndustry,
        );
        setIndustryDomain(filtered);
      })
      .catch((error) => console.error("Domain error:", error));
  }, [selectedIndustry]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "resume") {
      setFormData((prev) => ({ ...prev, resumeFile: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name === "resume" ? "resume" : name];
      return newErrors;
    });
  };

  const handleIndustryChange = (e) => {
    setSelectedIndustry(e.target.value);
  };

  const handleDomainChange = (e) => {
    setSelectedIndustryDomain(e.target.value);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName) {
      newErrors.firstName = "First name is required";
    } else if (formData.firstName.length > 25) {
      newErrors.firstName = "First name should not exceed 25 characters";
    }

    if (!formData.lastName) {
      newErrors.lastName = "Last name is required";
    } else if (formData.lastName.length > 25) {
      newErrors.lastName = "Last name should not exceed 25 characters";
    }

    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Valid email is required";
    }

    if (!formData.phoneNumber || !/^[6789]\d{9}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Valid 10-digit phone number is required";
    }

    if (!formData.resumeFile) {
      newErrors.resume = "Resume file is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const generatePasswordWithName = (name) => {
    return name + "@123";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const { firstName, lastName, email, phoneNumber, resumeFile } = formData;

    const password = generatePasswordWithName(firstName);
    const gigTalent = {
      firstName,
      lastName,
      email,
      phoneNumber,
      industry: selectedIndustry,
      domain: selectedIndustryDomain,
      password,
      type: "gigler",
      createdBy: "PeopleProcessTeckweb",
    };

    try {
      const result = await axios.post(`${BASE_URL}/api/users/`, gigTalent);
      const gigId = result?.data?.result?.data?.id;

      const register = {
        userId: gigId,
        firstName,
        lastName,
        email,
        phoneNumber,
        industry: selectedIndustry,
        domain: selectedIndustryDomain,
      };

      const data = await axios.post(
        `${BASE_URL}/api/userInfo/create`,
        register,
      );
      const uId = data?.data?.result?.data?.userId;

      const fileData = new FormData();
      fileData.append("resume", resumeFile);
      fileData.append("id", uId);

      const resumeUpload = await axios.post(
        `${BASE_URL}/api/userUploads/resume`,
        fileData,
      );
      if (resumeUpload) {
        alert("Resume Successfully uploaded");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",

          resumeFile: "",
        });
        setSelectedIndustry("Select Industry");
        setSelectedIndustryDomain("Select Domain");
        const resumeInput = document.getElementById("resumeInput");
        if (resumeInput) {
          resumeInput.value = "";
        } else {
          setShowToast({ message: "Resume upload failed.", type: "error" });
        }
      }
    } catch (err) {
      alert("Some Error occured, Please try again");
      console.error(err);
      setShowToast({
        message: "Something went wrong. Please try again.",
        type: "error",
      });
    }
  };
  const isFormIncomplete =
    !formData.firstName ||
    !formData.lastName ||
    !formData.email ||
    !formData.phoneNumber ||
    !selectedIndustry ||
    !selectedIndustryDomain ||
    !formData.resumeFile;

  return (
    <>
      <Navbar />
      <section className="relative lg:h-[75vh] md:h-[500px] sm:h-[400px] w-full rounded-tl-[390px] ">
        <img
          src={job_application}
          alt="Job Application"
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 bg-black bg-opacity-75 flex flex-col justify-center items-center gap-3">
          <h1 className="text-white text-4xl lg:text-8xl font-bold">
            Apply Now
          </h1>
          <p className="text-white text-lg lg:text-2xl mt-2 text-center">
            Your Staffing Needs are Unique and Always Evolving
          </p>
        </div>
      </section>

      <section className="text-center mt-10">
        <h1 className="text-primary">JOB OPPORTUNITIES</h1>
        <h2 className="text-3xl font-medium mt-2">
          Apply Now For Your Dream Job
        </h2>
        <p className="text-lg mt-2">
          Fill out the form & we’ll be in touch shortly.
        </p>
      </section>

      <form
        onSubmit={handleSubmit}
        className="m-10 xl:mb-32 grid grid-cols-1 xl:grid-cols-2 gap-10"
      >
        <div className="p-7 shadow-xl shadow-slate-400 space-y-4">
          <h3 className="text-2xl mb-3 flex items-center gap-3">
            <img src={basic_info} alt="Basic Info" className="h-10 w-10" />{" "}
            Basic Information
          </h3>
          <p>Please fill out your contact person details here.</p>
          <input
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="First Name"
            className="w-full p-2 border rounded border-gray-500"
          />
          {errors.firstName && (
            <p className="text-red-500">{errors.firstName}</p>
          )}

          <input
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Last Name"
            className="w-full p-2 border rounded border-gray-500"
          />
          {errors.lastName && <p className="text-red-500">{errors.lastName}</p>}

          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className="w-full p-2 border rounded border-gray-500"
          />
          {errors.email && <p className="text-red-500">{errors.email}</p>}

          <input
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="Phone Number"
            className="w-full p-2 border rounded border-gray-500"
          />
          {errors.phoneNumber && (
            <p className="text-red-500">{errors.phoneNumber}</p>
          )}
        </div>

        <div className="p-7 shadow-xl shadow-slate-400 space-y-4">
          <h3 className="text-2xl mb-3 flex items-center gap-3">
            <img
              src={qualification}
              alt="Qualification"
              className="h-10 w-10"
            />{" "}
            Qualification
          </h3>
          <p>Please fill out your qualification details here.</p>

          {/* <input name="education" value={formData.education} onChange={handleChange} placeholder="Education" className="w-full p-2 border rounded" />
          {errors.education && <p className="text-red-500">{errors.education}</p>} */}

          {/* <input name="experience" value={formData.experience} onChange={handleChange} placeholder="Total Experience" className="w-full p-2 border rounded" />
          {errors.experience && <p className="text-red-500">{errors.experience}</p>} */}

          <select
            select
            value={selectedIndustry}
            onChange={handleIndustryChange}
            className="w-full p-2 border rounded border-gray-500"
          >
            <option disabled>Select Industry</option>
            {industryData.map((ind) => (
              <option key={ind.Industry} value={ind.Industry}>
                {ind.Industry}
              </option>
            ))}
          </select>
          {errors.selectedIndustry && (
            <p className="text-red-500">{errors.selectedIndustry}</p>
          )}

          <select
            value={selectedIndustryDomain}
            onChange={handleDomainChange}
            className="w-full p-2 border rounded border-gray-500"
          >
            <option disabled>Select Domain</option>
            {industryDomain.map((dom) => (
              <option key={dom.Domain} value={dom.Domain}>
                {dom.Domain}
              </option>
            ))}
          </select>
          {errors.selectedIndustryDomain && (
            <p className="text-red-500">{errors.selectedIndustryDomain}</p>
          )}
          <input
            name="resume"
            type="file"
            id="resumeInput"
            onChange={handleChange}
            className="w-full p-2 border rounded border-gray-500"
          />
          {errors.resume && <p className="text-red-500">{errors.resume}</p>}
        </div>

        <div className="col-span-1 xl:col-span-2 mt-5">
          <button
            type="submit"
            disabled={isFormIncomplete}
            className={`mt-4 w-full text-white p-3 text-xl font-medium 
            ${isFormIncomplete ? "bg-gray-400 cursor-not-allowed" : "bg-primary hover:bg-red-600"}`}
          >
            Apply For Job
          </button>
        </div>
      </form>
      {showToast && (
        <Toast
          message={showToast.message}
          type={showToast.type}
          onClose={() => setShowToast("")}
        />
      )}

      <Footer />
    </>
  );
};

export default JobApplication;
